import { SegmentDefinition } from 'dashboard/pages/Segment/components';

export interface SegmentCompressed {
  id: string;
  definition: SegmentDefinition;
}

export enum ThenType {
  ChecklistItem = 'ChecklistItem',
  Css = 'Css',
}

export interface ThenConditional {
  type: ThenType;
  nodeId?: string;
  css?: object;
}

export interface Conditional {
  if: SegmentCompressed;
  then: ThenConditional[];
}
